import { useContext } from "react";
import AuthContext from "../Context/auth_provider.jsx";

const useAuth = () => useContext(AuthContext)
export default useAuth;
